// extracted by mini-css-extract-plugin
export default {"mainContainer":"TimelineList_mainContainer__CyVME","childrenContainer":"TimelineList_childrenContainer__rZ+uc"};